import { defineComponent as _defineComponent } from 'vue'
import BCXDottedBox from '@/components/molecules/BCXDottedBox.vue';
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import X from '@/components/svg-components/X.vue';
import useI18n from '@/mixins/useI18n';
import useResponsiveness from '@/mixins/useResponsiveness';
import type { RouterEntry } from '@/models/Router';
import { onClickOutside, useEventListener } from '@vueuse/core';
import {
  computed, onMounted, ref
} from 'vue';

export type BlogArticleTocItem = {
  id: string;
  text: string;
  level: 1 | 2 | 3;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogArticleToc',
  props: {
    items: null,
    overviewRoute: { default: undefined },
    variant: { default: 'default' }
  },
  emits: ["navigate", "back-to-top"],
  setup(__props: any, { emit }: { emit: ({(e: 'navigate', id: string): void;
  (e: 'back-to-top'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: BlogArticleTocItem[], overviewRoute: RouterEntry['to'], variant: 'default' | 'internal' };





const { t } = useI18n();
const { isSmartphoneWidth } = useResponsiveness();
const tocRoot = ref<HTMLElement | null>(null);
const isOpen = ref(false);
const isSticky = ref(false);
const stickyTop = computed(() => (props.variant === 'internal' ? 46 : 50));
const rootStyle = computed(() => ({
  '--toc-sticky-top': `${stickyTop.value}px`,
}));

const updateStickyState = () => {
  if (!tocRoot.value) return;
  isSticky.value = tocRoot.value.getBoundingClientRect().top <= stickyTop.value + 1;
};

onClickOutside(tocRoot, () => {
  if (!isOpen.value) return;
  isOpen.value = false;
});

useEventListener(window, 'scroll', updateStickyState, { passive: true });
useEventListener(window, 'resize', updateStickyState);

onMounted(() => {
  updateStickyState();
});

const navigateToItem = (id: string) => {
  emit('navigate', id);
  isOpen.value = false;
};

const navigateToTop = () => {
  emit('back-to-top');
  isOpen.value = false;
};

return { __sfc: true,props, emit, t, isSmartphoneWidth, tocRoot, isOpen, isSticky, stickyTop, rootStyle, updateStickyState, navigateToItem, navigateToTop, BCXDottedBox, BCXIcon, X }
}

})